import {debug} from './settings';
import {local} from './settings';

export function getSocketAddress(){

    if(debug === true && local === true){
        return 'ws://localhost:8000/ws/';
    }else if(debug === true && local === false){
        return 'wss://api-dev.capitalirrigation.com/ws/';
    }else if(debug === false && local === false){
        return 'wss://api.capitalirrigation.com/ws/';
    }
}